/**
 * This links to the JSD project: https://customerfeedback.atlassian.net/jira/servicedesk/projects/ADS/queues/custom/647
 */
export const REQUEST_TYPE_ID = '456';
export const JSD_URL = `https://jsd-widget.atlassian.com/api/embeddable/${process.env.GATSBY_JSD_WIDGET_EMBEDDABLE_KEY}/request?requestTypeId=${REQUEST_TYPE_ID}`;
